import React, {useState, useRef, useEffect}  from 'react'
import '@/assets/css/goods.scss';
import { useParams, useHistory } from 'react-router-dom'
import {langPath} from "@/util";
import {REQUEST} from "@/api";
import intl from 'react-intl-universal'
import newImg from '@/assets/img/icon/new.png'

const GoodsDec = () => {
    const [offset2, setOffset2] = useState(10)
    const [stley2, setStyle2] = useState({})
    const [categoryInfo, setCategoryInfo] = useState({})
    const [goodsInfo, setGoodsInfo] = useState({})
    const [recommondGoodsList, setRecommondGoodsList] = useState([])

    const refBox2 = useRef()
    const history = useHistory()
    const params = useParams()

    const cateId = params.id || ''

    const scrollBox2Fun = () => {
        let textBox2 = refBox2.current
        if (textBox2) {
            if (Math.abs(offset2) >= textBox2.scrollWidth) {
                setOffset2(0)
            }
            else {
                let step = -2
                setOffset2(offset2 => offset2 + step)
                setStyle2({
                    transform: `translate3d(${offset2}px, 0, 0)`
                })
            }
        }
    }
    const fetchRecommondsList = (categoryId, type) => {
        const data = {
            categoryId,
            type
        }
        REQUEST('recommendByCategoryId', data).then((res) => {
            setRecommondGoodsList([...res.body])
        })
    }
    const fetchGoodsList = (seriesId, type) => {
        const data = {
            type,
            limit: 50,
            page: 1,
            shelves: '1',
            seriesId
        }
        REQUEST('goodsListById', data).then((res) => {
            // // this.goodsList = [...res.body.list]
            if (res.body.list.length > 0) {
                const cateInfo = {}
                cateInfo.content = res.body.list[0].content
                cateInfo.categoryName = res.body.list[0].categoryName
                setCategoryInfo(cateInfo)
            }
            reset(res.body.list)
        })
        function reset(list) {
            const length = list.length
            if (length % 2 === 0) {
                //    偶数
                setGoodsInfo(getResetObj(list, 6))
            } else {
                //    奇数
                setGoodsInfo(getResetObj(list, 5))
            }
        }
        function getResetObj(arr, num = 7) {
            const obj = {
                other: []
            }
            for (let i = 1; i <= num; i++) {
                for (let j = 0; j < arr.length; j++) {
                    const item = arr[j]
                    // eslint-disable-next-line eqeqeq
                    if (item.goodsAddress == i) {
                        obj['item' + i] = item
                        continue
                    }
                }
            }
            for (let j = 0; j < arr.length; j++) {
                const item = arr[j]
                if (item.goodsAddress > num) {
                    obj.other.push(item)
                }
            }
            console.log(obj)
            return obj
        }
    }

    const goDetail = (val) => {
        let path = '/goods/' + val.goodsCode
        history.push(langPath(path))
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }
    const changeCate = (item) => {
        history.push(langPath(`/dec/${item.id}`))
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        window.location.reload()
    }
    const initData = () => {
        const type = intl.getInitOptions().currentLocale === 'zh-CN' ? '1' : '2'
        const seriesId = params.id
        fetchGoodsList(seriesId, type)
        fetchRecommondsList(seriesId, type)
    }

    useEffect(() => {
        requestAnimationFrame(scrollBox2Fun)
    }, [offset2])
    useEffect(() => {
        initData()
    }, [cateId])
    return (
        <div className="rl">
            <div className="rl-container rl-goods flex-column">
                <div className="rl-dec-goods flex-column-center">
                    <div className="rl-dec-head">
                        <h3 className="rl-dec-title">{categoryInfo.categoryName}</h3>
                        <div className="rl-dec-des">{categoryInfo.content}</div>
                    </div>
                    <div className="rl-dec-btn">See more</div>
                    <div className="rl-dec-img">
                        <div className="img">
                            <img src={goodsInfo.item1 && goodsInfo.item1.image} onClick={() => goDetail(goodsInfo.item1)} alt=""/>
                        </div>
                        <div className="news-img my-animation rotate360">
                            <img src={newImg} alt=""/>
                        </div>
                    </div>
                    <div className="rl-goods-dec">
                        <div className="goods-item-img s">
                            <div className="img">
                                <img src={goodsInfo.item2 && goodsInfo.item2.image} onClick={() => goDetail(goodsInfo.item2)} alt=""/>
                            </div>
                            <p className="info-ctr">See more</p>
                        </div>
                        <div className="goods-item-img s">
                            <div className="img">
                                <img src={goodsInfo.item3 && goodsInfo.item3.image} onClick={() => goDetail(goodsInfo.item3)} alt=""/>
                            </div>
                            <p className="info-ctr">See more</p>
                        </div>
                        {
                            goodsInfo.item6 &&
                            (<p className="goods-item-img w" onClick={() => goDetail(goodsInfo.item4)}>
                                <div className="img">
                                    <img src={goodsInfo.item4 && goodsInfo.item4.image} alt=""/>
                                </div>
                                <p className="info-ctr">See more</p>
                            </p>)
                        }
                        <div className="goods-item-img s">
                            <div className="img">
                                {
                                    goodsInfo.item6 &&
                                    (
                                        <img src={goodsInfo.item5 && goodsInfo.item5.image} onClick={() => goDetail(goodsInfo.item5)} alt=""/>
                                    )
                                }
                                {
                                    !goodsInfo.item6 &&
                                    (
                                        <img src={goodsInfo.item4 && goodsInfo.item4.image} onClick={() => goDetail(goodsInfo.item4)} alt=""/>
                                    )
                                }
                            </div>
                            <p className="info-ctr">See more</p>
                        </div>
                        <div className="goods-item-img s">
                            <div className="img">
                                {
                                    goodsInfo.item6 &&
                                    (
                                        <img src={goodsInfo.item6 && goodsInfo.item6.image} onClick={() => goDetail(goodsInfo.item6)} alt=""/>
                                    )
                                }
                                {
                                    !goodsInfo.item6 &&
                                    (
                                        <img src={goodsInfo.item5 && goodsInfo.item5.image} onClick={() => goDetail(goodsInfo.item5)} alt=""/>
                                    )
                                }
                            </div>
                            <p className="info-ctr">See more</p>
                        </div>
                    </div>

                </div>
                <ul className="rl-goods-list">
                    {
                        goodsInfo.other && goodsInfo.other.map((val => {
                            return (
                                <li className="rl-goods-item" key={val.goodsCode} onClick={() => goDetail(val)}>
                                    <div className="goods-item-img">
                                        <div className="img-box">
                                            <img src={val.image} alt=""/>
                                        </div>
                                    </div>
                                    <div className="goods-item-info flex-between">
                                        <div className="info-text flex-row-start">{val.goodsName}</div>
                                        <p className="info-ctr">Click it</p>
                                    </div>
                                </li>
                            )
                        }))
                    }
                </ul>
                <div className="rl-goods-recommend flex-column">
                    <div className="rl-recommend-scroll flex-row-start">
                        <div className="img-boxs recommend flex-row-start" ref={refBox2} style={stley2}>
                            <div className="img-box ">
                                <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/goods/recommendation.png" alt="" />
                            </div>
                        </div>
                    </div>
                    {
                        recommondGoodsList.length > 0 && (
                            <div className="rl-recommend-list">
                                <div className="recommend-item" onClick={() => changeCate(recommondGoodsList[0])}>
                                    <div className="img-box">
                                        <img src={recommondGoodsList[0].url} alt=""/>
                                    </div>
                                    <div className="img-info">{recommondGoodsList[0].name}</div>
                                </div>
                                <div className="recommend-item" onClick={() => changeCate(recommondGoodsList[1])}>
                                    <div className="img-box">
                                        <img src={recommondGoodsList[1].url} alt=""/>
                                    </div>
                                    <div className="img-info">{recommondGoodsList[1].name}</div>
                                </div>
                                <div className="recommend-tip flex-center">
                                    { intl.get('recommend') }
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}
export default GoodsDec
